import { useContext, useEffect, useSyncExternalStore } from 'react';
import '../../Default.css';
import '../../user/User.css'
import { Link } from 'react-router-dom';
import { dynamicPositionStore } from '../../map/dynamicPositionStore';
import { AuthProvider } from '../../globalContext';
import { userStateStore } from './usersStateStore';


function UserRender(id: string) {

    const user = (useSyncExternalStore(userStateStore.subscribe.bind(null,id),userStateStore.getUser.bind(null,id)))!

    
    const hasPosition = dynamicPositionStore.getPlayerCord(user._id) !== null
    const {id: userID, admin} = useContext(AuthProvider)

    const localizeButton = 
      hasPosition ?
      <Link to={`/map?userId=${user._id}`} className='btn'>Pokaż na mapie</Link> :
      <span>Brak ostatniej znanej pozycji</span>

    const canShowHistory : boolean = user._id === userID || admin
    const historyButton = canShowHistory ? <Link to={`/map-history?userId=${user._id}`} className='btn'>Pokaż przebytą trasę</Link> :
    <></>

    useEffect(()=>{
      fetch(`/api/user/${user._id}`)
      .then(res =>{
        if(res.status === 200){
          res.json()
          .then((newUserState)=>{
            if(newUserState.description !== user.description){
              // console.log(newUserState)
              // console.log(user)
              userStateStore.updateCallback(user._id,newUserState)
            }
          })
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
      <div>
        <div className="page-title">
          {user.name} {user.surname}
        </div>
        <div className='boxes-contener'>
          <div className='text-box'>
            <div className='user-data-table'>
              <div className='user-data-table-row'>
                <p className='user-data-table-row-key'>kod ZHR</p>
                <p className='user-data-table-row-value'>{user.zhr_code}</p>
              </div>
              <div className='user-data-table-row'>
                <p className='user-data-table-row-key'>opis</p>
                <p className='user-data-table-row-value'>{user.description}</p>
              </div>
            </div>
          </div>
          <div className='boxes-contener'>
            {localizeButton}
          </div>
          <div className='boxes-contener'>
            {historyButton}
          </div>
        </div>
      </div>
    );
}

export default UserRender;
